module.exports = __webpack_public_path__ + "img/4.72c9ecb8.png";